import * as React from 'react';
import store from "../../storeWire";
import { system_notification } from "../../store/slice/system";
import PriceTable from 'src/component/Global/Cart/PriceTable';
import { Tooltip } from 'src/component/Tooltip';
import { isNumber } from "underscore";
import getSymbolFromCurrency from "currency-symbol-map/currency-symbol-map";
import FactoryLeadTimeDisplay from 'src/component/Product/FactoryLeadTimeDisplay';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import Constants from 'src/support/Constants';
import Helper from 'src/support/Helper';
import useCheckAuthPermissions from 'src/hooks/component/useCheckAuthPermissions';
import NavigateToPDP from 'src/component/Global/Product/NavigateToPDP';
import { useProductInventoryStore } from "../../hooks/productInventory";

export function ViewOpenQuote(props) {
    const { currentQuote } = props;
    const [__check] = useAxiosIndicatorCheck();
    const [_check_p] = useCheckAuthPermissions();

    const openContactUsPopup = (val) => {
        store.dispatch(system_notification({
            name: 'ContactUsPopup',
            data: { restrict: val != undefined ? val : false },
        }));
    };

    const deleteQuotePopUp = (quote) => {
        if (_check_p('QT_BUY_NOW').status === false) {
            openContactUsPopup(true)
        }
        else {
            store.dispatch(system_notification({
                name: 'DeleteQuotePopup',
                data: {
                    current_quote: quote
                },
            }));
        }
    }

    const editQuotePopUp = (quote) => {
        if (_check_p('QT_BUY_NOW').status === false) {
            openContactUsPopup(true)
        }
        else {
            store.dispatch(system_notification({
                name: 'QuotePopup',
                data: {
                    single_product: quote.product,
                    current_quote: quote
                },
            }));
        }
    }

    return (
        <>
            {currentQuote !== undefined &&
                <tr>
                    <td>
                        <div className="edit-quote-ic">
                            <a href={void (0)} data-toggle="modal" data-target="#delete-quote-Modal"
                                onClick={() => deleteQuotePopUp(currentQuote)}><i className="fa fa-trash" /></a>
                            <a href={void (0)} className="text-blue" onClick={() => editQuotePopUp(currentQuote)}><i className="fa fa-pencil" /></a>
                        </div>
                    </td>
                    <td>
                        <div className="bs5 row">
                            <div className="col-12">Manufacturer:&nbsp;
                                {currentQuote?.product?.ManufacturerName}
                            </div>

                        </div>
                        <div className="bs5 row">
                            <div className="col-12">Mfg Part #:&nbsp;
                                <NavigateToPDP data={{
                                    ManufacturerName: currentQuote?.product?.ManufacturerName,
                                    ERPMFRPartNumber: currentQuote?.product?.ERPMFRPartNumber,
                                    ItemNumber: currentQuote?.product?.ItemNumber,
                                }}>
                                    <div className="text-blue">
                                        <b>{currentQuote?.product?.ERPMFRPartNumber}</b>
                                    </div>
                                </NavigateToPDP>

                            </div>
                        </div>

                        {currentQuote.customerPartNumber && currentQuote.customerPartNumber.length > 1 &&
                            <>
                                <label className="mt-2"><b>Customer Part Number </b>
                                    <Tooltip
                                        opener={() => (
                                            <i className="fa fa-info-circle me-2" />
                                        )}
                                        content={() => (
                                            <>
                                                {'Pricing is associated with displayed Customer Part Number (CPN). If a different CPN is selected, pricing will be re-determined.'}
                                            </>
                                        )}
                                    />

                                </label>
                                <div>
                                    <div>{currentQuote.customerPartNumber}</div>
                                </div>
                            </>
                        }
                    </td>
                    <td>
                        <div>{currentQuote.quantity1 > 0 ? currentQuote.quantity1 : Constants.noValue}</div>
                        <div>{currentQuote.quantity2 > 0 ? currentQuote.quantity2 : Constants.noValue}</div>
                        <div>{currentQuote.quantity3 > 0 ? currentQuote.quantity3 : Constants.noValue}</div>
                    </td>
                    <td>
                        <div className="bs5 row">
                            <div className="col-6">
                                <div>
                                    {/* {currentQuote.targetUnitPrice > 0 ? currentQuote.targetUnitPrice : Constants.noValue} */}
                                    {(currentQuote.targetUnitPrice && currentQuote.targetUnitPrice > 0) ? Helper.getFormatNumber(currentQuote.targetUnitPrice, currentQuote.targetCurrency, true, 5) : Constants.noValue}

                                </div>
                            </div>
                            <div className="col-6">
                                {currentQuote.targetCurrency}: {getSymbolFromCurrency(currentQuote.targetCurrency)}
                            </div>
                        </div>
                    </td>
                    <td>
                        <div className="price-table-list">
                            {currentQuote.product?.assets?.pricing && currentQuote.product?.assets?.pricing?.length > 0 ?
                                <PriceTable
                                    isDisplayCPN={false}
                                    single_product_pricing_list={currentQuote.product?.assets?.pricing}
                                    single_product_inventory={currentQuote.product?.assets?.inventory}
                                    single_product={currentQuote.product} />
                                : <div>_______</div>}
                        </div>
                    </td>
                    <td>
                        {/* <ProductInventoryDisplay single_product={currentQuote.product} isFrom={Constants.isFrom.OPEN_QUOTE} single_product_inventory={get_inventory_by_id(currentQuote.product?.ERPPartNumber)} /> */}
                        <ul className="list-text availibility-list-text">
                            <li className="text-darkgreen">
                                <span
                                    className="d-flex text-darkgreen w-100">
                                    <b>In Stock:</b>
                                    <b className="ms-auto">{isNumber(currentQuote.product?.assets?.inventory.qas) && currentQuote.product?.assets?.inventory.qas > 0 ? currentQuote.product?.assets?.inventory.qas : currentQuote.product?.assets?.inventory.qas}</b>
                                    <i style={{ visibility: __check(['PRODUCT_INVENTORY_API_CALL']).status ? 'hidden' : 'visible' }}
                                        className="fa fa-check-circle ms-2"></i>
                                </span>
                            </li>
                            <li>
                                <i className="fa fa-level-up me-2 d-none" />
                                <span><b>Additional Inventory</b> </span>
                            </li>
                            <li>
                                <i className="fa fa-level-up me-2" />
                                <div className="d-flex flex-column w-100">
                                <FactoryLeadTimeDisplay
                                    single_product={currentQuote.product}
                                    single_product_inventory={currentQuote.product?.assets?.inventory} />
                                </div>
                            </li>
                        </ul>
                    </td>
                    <td>
                        <div><b>End Customer: </b> {currentQuote.endCustomer}</div>
                        <div><b>Competition: </b> {currentQuote.competition}</div>
                        <div><b>Comments: </b> {currentQuote.comments}</div>
                    </td>
                </tr>
            }
        </>
    );
}
